import React from 'react';
import './Success.css';

const Success = ({ navTo }) => {
  return (
    <div className="success-page-wrapper">
      <main className="success-page-main">
        <div className="success-page-content">
          <div className="success-page-icon">🎉</div>
          <h1 className="success-page-title">Спасибо за покупку!</h1>
          <p className="success-page-subtitle">
            Ваша подписка успешно активирована.<br />
            Приятного использования!
          </p>
          <button 
            className="success-page-button"
            onClick={() => navTo('overview')}
          >
            Вернуться на главную
          </button>
        </div>
      </main>
    </div>
  );
};

export default Success;